import React,{Component} from 'react'
import {connect } from 'react-redux';
import {Link } from 'react-router-dom';
import {logOut} from '../../Redux/ducks/authReducer';
export class Nav extends Component{
   
    render(){
        return (
            <div>
                <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
                    <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                    <i className="fa fa-bars"></i>
                    </button>

                    
                    <div className="innerTitle">ST. JOHNS' SS ONLINE APPLICATION</div>
                    <ul className="navbar-nav ml-auto">

                        
                        <div className="topbar-divider d-none d-sm-block"></div>
                        <li className="nav-item ">
                            <Link to="/login"  className="dropdown-item">
                                <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                                Logout
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>
        )
    }
}
const mapStateToProps = (state) =>({
    
});
export default connect(
    mapStateToProps,{logOut}
)(Nav)
